import { Stack, Icon, Text } from '@fluentui/react';
import { FunctionComponent } from 'react';
import { DistributionResult } from '../../../../../../Entities/ActivityDistribution/DistributionResult';
import { DistributionResultType } from '../../../../../../Entities/ActivityDistribution/Enums';
import { IExtendedTheme } from '../../../../../../Themes/Theme.types';
import { ArrayEx } from '../../../../../../Utilities/ArrayEx';
import EnumEx from '../../../../../../Utilities/EnumEx';
import { useTranslation } from '../../../../../../Locales/i18n/localizationService';

interface IProps {
    theme: IExtendedTheme;
    result: DistributionResult;
}

export const DistributionFail: FunctionComponent<IProps> = props => {
    const { t } = useTranslation();
    const getResultTypes = (resultType: DistributionResultType): Array<DistributionResultType> => {
        const results = EnumEx.getFlagValues<DistributionResultType>(DistributionResultType, resultType);
        return results;
    };

    return (
        <>
            <Stack horizontalAlign="center" styles={{ root: { width: '100%' } }}>
                <Icon
                    iconName="Warning"
                    styles={{ root: { color: props.theme.semanticColors.errorIcon, fontSize: 26, cursor: 'help' } }}
                    title={ArrayEx.objectJoinToString(getResultTypes(props.result.Result), ', ', _ => DistributionResultType[_])}
                />
                <Text variant="xLarge" styles={{ root: { color: props.theme.semanticColors.errorIcon } }}>
                    {t('AutoAllocationDialog.NotPossible')}
                </Text>
                <Text variant="mediumPlus">{t('AutoAllocationDialog.CannotFullfillRequest')}</Text>
            </Stack>
        </>
    );
};
